import { createSelector } from '@reduxjs/toolkit';

import { selectAllImprovements } from './propertyDataSelectors/improvementsSelectors.ts';

export const selectOrderHasManufacturedAndNonManufacturedProperties = createSelector(
  [selectAllImprovements],
  (improvements) =>
    improvements.some((improvement) => improvement.propertyType === 'manufacturedHome') &&
    improvements.some((improvement) => improvement.propertyType !== 'manufacturedHome'),
);
